import type { CompanyArticleType } from "@/modules/companies/client/api/contentBoostTypes"
import type { TFunction } from "@/modules/i18n/components/types"

export const getArticleTranslationKey = (type: CompanyArticleType, t: TFunction<"companies_client">): string => {
  return {
    ARTICLE_TYPE_CHALLENGE: t("companies_client.content_boosts.article_type.challenge"),
    ARTICLE_TYPE_CORPORATE_SOCIAL_RESPONSIBILITY: t(
      "companies_client.content_boosts.article_type.corporate_social_responsibility"
    ),
    ARTICLE_TYPE_MEETING: t("companies_client.content_boosts.article_type.meeting"),
    ARTICLE_TYPE_OTHER: t("companies_client.content_boosts.article_type.other"),
    ARTICLE_TYPE_RECRUITMENT: t("companies_client.content_boosts.article_type.recruitment"),
    ARTICLE_TYPE_UNSPECIFIED: t("companies_client.content_boosts.article_type.unspecified"),
  }[type]
}
